// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorPricePreferences = (client) => ({
    /**
     * `GET /vendor/price-preferences`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListPricePreferences
     * @source packages/modules/b2c-core/src/api/vendor/price-preferences/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/price-preferences", { method: "GET", query, headers }),
});
//# sourceMappingURL=price-preferences.js.map